import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { isPlatformBrowser, isPlatformServer } from
  '@angular/common';

declare var $: any;
import { AuthService } from '../../core/services';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css']
})
export class AdminLayoutComponent implements OnInit {

  userName:any;
  
  constructor(private router: Router,
    private _route: ActivatedRoute,
    private authSvc: AuthService,
    @Inject(PLATFORM_ID) private platform: Object
  ) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platform)) {
      // var userRoles: any = JSON.parse(sessionStorage.getItem('USER') || '{}');
      const currentUser = JSON.parse(sessionStorage.getItem('USER'));
      this.userName = currentUser.user.name;
    }
    if (isPlatformBrowser(this.platform)) {
      $(document).ready(function () {
        $('.button-left').click(function () {
          // console.log("on click")

          $('.sidebar').toggleClass('fliph');
          $('.sidebar-width').toggleClass('fliph');
        });
        $('.button-left').mouseover(function () {
          // console.log("on hover")
          $('.sidebar').toggleClass('fliph');
          $('.sidebar-width').toggleClass('fliph');
        });
      });
    }
  }

  // var = (' hover-me').mouseover(function(){
  //   $(" #sideBar").show();

  // });
  // $(" #sideBar").mouseleave(function(){ $(this).hide(); })




  logout() {
    this.authSvc.logout();
    this.router.navigate(['/admin']);
  }

}
